import React, {useState, useRef, useEffect} from 'react';
import styles from './MainPage.module.scss';
import Radium from 'radium';
import axios from 'axios';


//recaptcha
import {GoogleReCaptchaProvider, useGoogleReCaptcha} from "react-google-recaptcha-v3";

//components
import ModalCustom from '../shared/ModalCustom';


//functions
import {changeFaToEn} from '../functions/changeFaToEn';
import {notify} from '../functions/toasts';
import {
    Step1Varification,
    Step2Varification,
} from '../functions/varificationCode';
import {runSend} from '../functions/runSend';
import sweetAlert from '../functions/sweetAlert';

//shared
import FixedVideo from '../shared/FixedVideo';



const MainPage = ({templateParameter, keyRender}) => {

    //recaptcha
    const {executeRecaptcha} = useGoogleReCaptcha();

    const bgColor = templateParameter.bgColor;
    const body = document.querySelector('body');

    body.style.backgroundColor = bgColor === '' ? '#f9f9f9' : bgColor;

    const [mobile, setMobile] = useState('');

    const [disabledBtn, setDisabledBtn] = useState(false);

    const [onOffModal, setOnOffModal] = useState('none');
    const [codeVarifivation, setCodeVarifivation] = useState('');

    const [resultVrification, setResultVrification] = useState(false);
    const modalVarificationButtonHandler = async () => {
        if (codeVarifivation === '') {
            notify('کد تاییدی وارد نکرده اید!', 'error');
            return;
        }

        const result2StepVarification = await Step2Varification(
            mobile,
            tokenPage,
            codeVarifivation
        );

        if (result2StepVarification) {
            setResultVrification(true);
        } else notify('کد وارد شده صحیح نیست', 'error');
    };

    const mainPic = templateParameter.mainPic;

    const matnSend1 = templateParameter.matnSend1;
    const colorMatnSend1 = templateParameter.colorMatnSend1;
    const sizeMatnSend1 = templateParameter.sizeMatnSend1;

    const matnSend2 = templateParameter.matnSend2;
    const colorMatnSend2 = templateParameter.colorMatnSend2;
    const sizeMatnSend2 = templateParameter.sizeMatnSend2;

    const textBtnSend = templateParameter.textBtnSend;
    const colorBtn = templateParameter.colorBtn;
    const colorTextBtn = templateParameter.colorTextBtn;
    const SizeTextBtn = templateParameter.SizeTextBtn;

    const centerText = templateParameter.centerText;
    const colorCenterText = templateParameter.colorCenterText;
    const SizeCenterText = templateParameter.SizeCenterText;

    const fixedVideo = templateParameter.fixedVideo ?? '';
    const posterFixedVideo = templateParameter.posterFixedVideo ?? '';
    const textFixedVideo = templateParameter.textFixedVideo ?? '';

    const tokenPage = templateParameter.token;
    const twoStep = templateParameter.twoStep;

    const regex = /^09\d{9}$/;
    const inputHandler = (e) => {
        const first = changeFaToEn(e.target.value);
        setMobile(first);
    };

  

    
    
    const submitHandler = async (e) => {
        e.preventDefault();
        setDisabledBtn(true);

        const checkMobile = regex.test(mobile);

        if (mobile === '') {
            // notify("شماره موبایل وارد نشده است", "error");
            sweetAlert('شماره موبایل وارد نشده است');
            setDisabledBtn(false);
            return;
        }

        if (!checkMobile) {
            // notify("شماره موبایل صحیح وارد نشده", "error");
            sweetAlert('شماره موبایل صحیح وارد نشده است');
            setDisabledBtn(false);
            return;
        }

        if (twoStep !== '') {
            setOnOffModal('flex');
            setDisabledBtn(false);
            const stepOneVarification = await Step1Varification(
                mobile,
                tokenPage
            );

            if (stepOneVarification[0])
                notify(stepOneVarification[1], 'success', 3000);
            else notify(stepOneVarification[1], 'error', 3000);
        }
        

        if (twoStep === '') {
            
            await runSend(mobile, setOnOffModal, setDisabledBtn, templateParameter, executeRecaptcha);
        }


    };

  
    if (resultVrification) {
        notify('کد تایید شد', 'success', 300);

        runSend(mobile, setOnOffModal, setDisabledBtn, templateParameter, executeRecaptcha);

        setResultVrification(false);
    }

    const myStyleBtn = {
        backgroundColor: colorBtn === '' ? '#0366ee' : colorBtn,
        color: colorTextBtn === '' ? '#fff' : colorTextBtn,
        fontSize: SizeTextBtn === '' ? '1.2rem' : `${SizeTextBtn}px`,

        ':hover': {
            backgroundColor:
                colorBtn === '' ? '#0366eed7' : `${colorBtn}d7`,
        },
    };

    const myInputStyle = {
        ':hover': {
            border:
                colorBtn === ''
                    ? '1px solid #2252fd95'
                    : `1px solid ${colorBtn}`,
        },
        ':focus': {
            border:
                colorBtn === ''
                    ? '1px solid #2252fd95'
                    : `1px solid ${colorBtn}`,
        },
    };

    return keyRender ? (
        <>
            {onOffModal === 'flex' && (
                <ModalCustom
                    mobile={mobile}
                    onOffModal={onOffModal}
                    setOnOffModal={setOnOffModal}
                    codeVarifivation={codeVarifivation}
                    setCodeVarifivation={setCodeVarifivation}
                    modalVarificationButtonHandler={
                        modalVarificationButtonHandler
                    }
                    tokenPage={tokenPage}
                />
            )}
            {fixedVideo !== '' && (
                <FixedVideo
                    videoUrl={fixedVideo}
                    posterUrl={posterFixedVideo}
                    text={textFixedVideo}
                />
            )}

            <div className={styles.mainCon}>
                {mainPic !== '' && (
                    <img
                        src={mainPic}
                        alt="mainPic"
                        className={styles.mainPic}
                    />
                )}

                {centerText !== '' && (
                    <div className={styles.textCon}>
                        <p
                            dangerouslySetInnerHTML={{__html: centerText}}
                            style={{
                                color:
                                    colorCenterText === ''
                                        ? '#333333'
                                        : colorCenterText,
                                fontSize:
                                    SizeCenterText === ''
                                        ? '1.1rem'
                                        : `${SizeCenterText}px`,
                            }}
                        ></p>
                    </div>
                )}
            </div>

            <div>
                <div
                    className={`${styles.c_subscribe_box} ${styles.u_align_center}`}
                >
                    <div className={styles.rainbow}>
                        <span></span>
                        <span></span>
                    </div>
                    <div className={styles.c_subscribe_box__wrapper}>
                        <div className={styles.bottomCon}>
              <span
                  className={styles.span1}
                  style={{
                      color:
                          colorMatnSend1 === ''
                              ? '#333333'
                              : colorMatnSend1,
                      fontSize:
                          sizeMatnSend1 === ''
                              ? '1.2rem'
                              : `${sizeMatnSend1}px`,
                  }}
              >
                {matnSend1}
              </span>
                            <span
                                className={styles.span2}
                                style={{
                                    color:
                                        colorMatnSend2 === ''
                                            ? '#333333'
                                            : colorMatnSend2,
                                    fontSize:
                                        sizeMatnSend2 === ''
                                            ? 'initial'
                                            : `${sizeMatnSend2}px`,
                                }}
                            >
                {matnSend2}
              </span>
                            <div>
                                <input
                                    key={'myin'}
                                    type="text"
                                    placeholder="09---------"
                                    value={mobile}
                                    onChange={inputHandler}
                                    style={myInputStyle}
                                />
                                <button
                                    key={'mybtn'}
                                    onClick={submitHandler}
                                    disabled={disabledBtn}
                                    style={myStyleBtn}
                                >
                                    {textBtnSend === '' ? 'ارسال شماره' : textBtnSend}
                                    {disabledBtn && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    ) : (
        <></>
    );
};


const MainPageContainer = ({templateParameter , keyRender}) => {
    return (
        <GoogleReCaptchaProvider
            reCaptchaKey="6Le6EWYpAAAAAFyebrNN_fc8C6zfjeiqrfHQ4MFP"
            scriptProps={{
                async: false,
                defer: false,
                appendTo: "head",
                nonce: undefined,
            }}
        >
            <MainPage  templateParameter={templateParameter} keyRender={keyRender}/>
        </GoogleReCaptchaProvider>
    )
}
export default MainPageContainer;
